import { getView, requireAuth } from '@/lib/utils';
import { AssetsPage } from '@/data/appInformationItems';
import { Left } from 'Models/Menu/menus';

export default {
  path: '/files',
  component: getView('pages/PageFiles'),
  name: 'files',
  beforeEnter: requireAuth,
  meta: {
    crumbs: 'Files',
    leftMenu: Left.FilesList,
    roles: ['operator'],
    information: AssetsPage,
    showBottomMenu: true,
  },
};
